import { Input, InputProps } from "antd";
import clsx from "clsx";
import React from "react";

interface AppInputProps extends Omit<InputProps, "className"> {
  valid?: boolean;
  invalid?: boolean;
  invalidText?: string;
  containerClassName?: string;
  inputClassName?: string;
}

const AppInput = (props: AppInputProps) => {
  const {
    valid = false,
    invalid = false,
    invalidText = false,
    containerClassName = "",
    inputClassName = "",
    ...inputProps
  } = props;

  return (
    <div className={clsx("flex flex-col items-start justify-center", containerClassName)}>
      <Input
        className={clsx(
          "input input-outline input-outline-primary",
          {
            valid: valid,
            invalid: invalid,
          },
          inputClassName,
        )}
        {...inputProps}
      />
      {invalid && <p className="text-xs text-danger mt-2">{invalidText}</p>}
    </div>
  );
};

export default AppInput;
